export default "__VITE_ASSET__CFL6EHrb__"